import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import styles from './note.styl'

export default class Note extends Component {
  static propTypes = {
    children: PropTypes.any,
    center: PropTypes.bool,
    lighter: PropTypes.bool,
    maxWidth: PropTypes.string,
    fontSize: PropTypes.string,
    intlKey: PropTypes.string,
    padding: PropTypes.string,
    margin: PropTypes.string,
    className: PropTypes.string,
    values: PropTypes.object,
    hideNodePrefix: PropTypes.bool
  }

  static defaultProps = {
    center: false,
    lighter: false,
    hideNodePrefix: false
  }

  renderContent = () => {
    const { intlKey, children, values, hideNodePrefix } = this.props

    if (intlKey) {
      return (
        <FormattedHTMLMessage
          id={intlKey}
          defaultMessage={typeof children === 'string' ? children : ''}
          values={values}
        />
      )
    }

    if (intlKey || hideNodePrefix) {
      return (<div>{children}</div>)
    }

    return (<div><FormattedMessage
      id='label.note'
      defaultMessage='Note'
    />: {children}</div>)
  }

  render() {
    const {
      className,
      margin,
      padding,
      fontSize,
      maxWidth,
      center,
      lighter
    } = this.props
    const noteClass = [styles.note]

    center && noteClass.push(styles.center)
    lighter && noteClass.push(styles.lighter)
    className && noteClass.push(className)

    return (
      <p
        className={noteClass.join(' ')}
        style={{ margin, padding, fontSize, maxWidth }}
      >
        {this.renderContent()}
      </p>
    )
  }
}
